/**
 * The note every screen that shows AI spend carries: the dollar figures
 * are estimates, and the supplier's bill is the actual cost.
 *
 * Why it exists. The cost figures here are mostly worked out from each
 * supplier's published prices, and some are the supplier's own figure.
 * Neither is what a customer is billed: a hosted customer's bill comes
 * from OttoCloud, a self-hoster's from their own supplier. A dollar sign
 * reads as an invoice amount unless something says otherwise.
 *
 * One component, so the words live in one place. Analytics, the run
 * drill-down and Org Settings › Usage all render this rather than their
 * own copy; a screen-specific variant would drift, and the point of the
 * note is that it says the same thing everywhere.
 *
 * Not `CostSourceNote`. That one tags a single figure as "as
 * billed", "estimated" or "part billed". This one speaks for the whole
 * screen, and the line under the headline keeps the distinction by
 * saying some figures are the supplier's own. Both stay.
 *
 * Lives in `components/bi/` rather than beside `CostSourceNote` in
 * `qualityReport/`, because Usage sits outside the analytics pages and
 * should not reach into the quality-report folder for it.
 *
 * Styling matches the hints already on these screens; the headline is
 * one step darker so it reads first. Spacing around it is the caller's,
 * passed as `className`, since each screen places it differently.
 */
export function CostEstimateNote({ className = '' }: { className?: string }) {
  return (
    <div className={`space-y-0.5 ${className}`.trim()}>
      <p className="text-xs font-medium text-foreground">
        Estimated. Check your model supplier for actual cost.
      </p>
      <p className="text-xs text-muted-foreground">
        These amounts are worked out from each AI supplier's published prices, or taken from the
        supplier's own figure when it gives one. Your bill from the supplier, or from OttoCloud if
        you buy AI from us, is the actual cost.
      </p>
    </div>
  )
}
